export default {
  PLAN_YOUR_TRIP: 'suggested-tours',
  EXPLORE_ON_YOUR_OWN_ROUTES: 'explore-on-your-own-routes',
  MLF: 'macao-light-festival',
  STEP_OUT_MACAO: 'step-out-macao',
  MACAO_FULL_OF_FUN: 'macao-full-of-fun',
}